import React, { Component } from 'react';

export default class ContentBreak extends Component {
  render() {
    const {
      anchor,
      image,
    } = this.props;
    return (
      <section id={anchor || undefined} className="content-break">
        <div className="content-break-line"/>
        <div className="content-break-image">
          <div className={image}/>
        </div>
        <div className="content-break-line"/>
      </section>
    );
  }
}
